module.exports = __webpack_public_path__ + "static/flags/MN-b596887401e40144959fa5d9244ebee5.gif";